export const buildV3Url = (path: string) => {
  if (!window.JobConfig) {
    return path
  }
  const sep = path.includes('?') ? '&' : '?'
  return `${window.JobConfig?.app_url}${path}${sep}jwt=${window.JobConfig?.user.jwt}&instance=${window.JobConfig?.instance.computedName}&userId=${window.JobConfig?.user.id}`
}
